// extracted by mini-css-extract-plugin
export default {"success_box":"Success_success_box__XZK-4"};